export default "__VITE_ASSET__d3cbca94__"